(function () {
  'use strict';

  var drawer = document.querySelector('[data-quick-cart]');
  if (!drawer) return;

  var itemsEl = drawer.querySelector('[data-quick-cart-items]');
  var emptyEl = drawer.querySelector('[data-quick-cart-empty]');
  var footerEl = drawer.querySelector('[data-quick-cart-footer]');
  var subtotalEl = drawer.querySelector('[data-quick-cart-subtotal]');
  var countEl = drawer.querySelector('[data-quick-cart-count]');
  var countWrapEl = drawer.querySelector('[data-quick-cart-count-wrap]');

  var isOpen = false;
  var isFetching = false;

  /* ---------- Price formatter (mirrors snippets/price.liquid for IN) ---------- */
  function formatIndianNumber(rupees) {
    var s = String(rupees);
    if (s.length <= 3) return s;
    var last3 = s.slice(-3);
    var rest = s.slice(0, -3);
    rest = rest.replace(/\B(?=(\d{2})+(?!\d))/g, ',');
    return rest + ',' + last3;
  }

  function formatPrice(cents) {
    var rupees = Math.round((cents || 0) / 100);
    return '₹' + formatIndianNumber(rupees);
  }

  /* ---------- Open / close ---------- */
  /* Re-render just the drawer body from Liquid. Used when we already have cart
     JSON and only need the server's markup for parity. */
  function refreshSection() {
    return fetch('/cart?sections=quick-cart-india', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        if (sections && sections['quick-cart-india']) {
          injectItemsFromSection(sections['quick-cart-india']);
        }
      })
      .catch(function () {});
  }

  function showPanel() {
    if (isOpen) return;
    isOpen = true;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    document.body.classList.add('quick-cart-open');
    var focusTarget = drawer.querySelector('.quick-cart__close');
    if (focusTarget) {
      setTimeout(function () { focusTarget.focus(); }, 320);
    }
  }

  function openDrawer(e) {
    var detail = (e && e.detail) || {};
    /* addToCart() below already painted the drawer from its own response. */
    if (detail.source === 'quick-cart') return;

    /* Other add-to-cart handlers fetched the cart before dispatching. Paint
       from that payload straight away so the drawer is usable immediately,
       then reconcile the markup in the background. */
    var cart = detail.cart;
    showPanel();
    if (cart) { renderCart(cart); refreshSection(); }
    else refreshCart();
  }

  function closeDrawer() {
    if (!isOpen) return;
    isOpen = false;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    document.body.classList.remove('quick-cart-open');
  }

  /* ---------- Render ---------- */
  function escapeHtml(str) {
    if (str == null) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function getColorOption(item) {
    if (item.properties && item.properties._color) return item.properties._color;
    if (item.options_with_values) {
      for (var i = 0; i < item.options_with_values.length; i++) {
        if (/colou?r/i.test(item.options_with_values[i].name)) {
          return item.options_with_values[i].value;
        }
      }
    }
    return null;
  }

  // Order-thumbnail helper images (alt / file name 'rr-order-thumb') exist only for
  // Shopify's hosted order pages. In the cart show the product's own photo instead:
  // mark the <img> and swap its src once the product JSON is fetched.
  var rrProductImageCache = {};
  function isOrderThumb(item) {
    var alt = (item.featured_image && item.featured_image.alt) || '';
    return /rr-order-thumb/i.test(alt) || /rr-order-thumb/i.test(item.image || '');
  }
  function swapOrderThumbs(scope) {
    if (!scope) return;
    scope.querySelectorAll('img[data-rr-product-handle]').forEach(function (img) {
      var handle = img.getAttribute('data-rr-product-handle');
      if (!handle) return;
      if (!rrProductImageCache[handle]) {
        rrProductImageCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js')
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (p) { return p && p.featured_image ? p.featured_image : null; })
          .catch(function () { return null; });
      }
      rrProductImageCache[handle].then(function (src) {
        if (!src) return;
        src = src.indexOf('//') === 0 ? 'https:' + src : src;
        img.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=320';
        img.removeAttribute('data-rr-product-handle');
      });
    });
  }

  function renderItem(item, shownDiscounts) {
    shownDiscounts = shownDiscounts || {};
    var imgSrc = '';
    if (item.image) {
      imgSrc = item.image.indexOf('?') > -1 ? item.image + '&width=320' : item.image + '?width=320';
    }

    var title = escapeHtml(item.product_title || item.title || '');
    var url = escapeHtml(item.url || '#');
    var key = escapeHtml(item.key);

    var brandHtml = '';
    if (item.vendor) {
      brandHtml = '<div class="quick-cart__item-brand">' + escapeHtml(item.vendor) + '</div>';
    }

    var variantHtml = '';
    var color = getColorOption(item);
    if (color) {
      variantHtml = '<div class="quick-cart__item-variant"><span class="quick-cart__item-variant-label">Color:</span> ' + escapeHtml(color) + '</div>';
    } else if (item.variant_title && item.variant_title !== 'Default Title') {
      variantHtml = '<div class="quick-cart__item-variant">' + escapeHtml(item.variant_title) + '</div>';
    }

    var compareHtml = '';
    if (item.original_line_price && item.original_line_price > item.final_line_price) {
      compareHtml = '<span class="quick-cart__item-price-compare">' + formatPrice(item.original_line_price) + '</span>';
    } else if (item.compare_at_price && item.compare_at_price > item.price) {
      compareHtml = '<span class="quick-cart__item-price-compare">' + formatPrice(item.compare_at_price * item.quantity) + '</span>';
    }

    var isGift = item.properties && item.properties._rr_gift === 'true' ? ' data-gift' : '';
    /* Same rule as the Liquid render: the gift (or any zero-priced line) reads FREE, not ₹0.00 */
    var isGiftItem = !!isGift || item.final_price === 0;

    var discountHtml = '';
    /* The gift's own discount only repeats the struck price + FREE, and the
       Free Backpack discount also tags each qualifying watch with ₹0. Show
       neither. */
    var allocs = isGiftItem ? [] : (item.line_level_discount_allocations || item.discount_allocations || []);
    if (allocs.length > 0) {
      discountHtml = allocs.map(function (alloc) {
        var t = (alloc.discount_application && alloc.discount_application.title)
              || alloc.title || 'Discount';
        var amt = alloc.amount != null ? alloc.amount : (alloc.total_amount || 0);
        if (!(amt > 0)) return '';
        if (shownDiscounts[t]) return '';
        shownDiscounts[t] = true;
        return '<div class="quick-cart__item-discount">'
          +   '<span class="quick-cart__item-discount-title">' + escapeHtml(t) + '</span>'
          +   '<span class="quick-cart__item-discount-amount">−' + formatPrice(amt) + '</span>'
          + '</div>';
      }).join('');
    }
    if (!discountHtml && !isGiftItem && item.original_line_price && item.original_line_price > item.final_line_price) {
      var saved1 = item.original_line_price - item.final_line_price;
      var pct1 = Math.round(saved1 * 100 / item.original_line_price);
      discountHtml = '<div class="quick-cart__item-discount">'
        +   '<span class="quick-cart__item-discount-title">' + pct1 + '% OFF</span>'
        +   '<span class="quick-cart__item-discount-amount">−' + formatPrice(saved1) + '</span>'
        + '</div>';
    }
    if (!discountHtml && !isGiftItem && item.compare_at_price && item.compare_at_price > item.price) {
      var original2 = item.compare_at_price * item.quantity;
      var saved2 = original2 - item.final_line_price;
      var pct2 = Math.round(saved2 * 100 / original2);
      discountHtml = '<div class="quick-cart__item-discount">'
        +   '<span class="quick-cart__item-discount-title">' + pct2 + '% OFF</span>'
        +   '<span class="quick-cart__item-discount-amount">−' + formatPrice(saved2) + '</span>'
        + '</div>';
    }

    return ''
      + '<li class="quick-cart__item" data-item-key="' + key + '"' + isGift + '>'
      +   '<a class="quick-cart__item-image" href="' + url + '" aria-label="' + title + '">'
      +     (imgSrc ? '<img src="' + escapeHtml(imgSrc) + '" alt="' + title + '" loading="lazy" width="180" height="180"'
      +       (isOrderThumb(item) && item.handle ? ' data-rr-product-handle="' + escapeHtml(item.handle) + '"' : '') + '>' : '')
      +   '</a>'
      +   '<div class="quick-cart__item-info">'
      +     '<a class="quick-cart__item-title" href="' + url + '">' + title + '</a>'
      +     brandHtml
      +     variantHtml
      +     '<div class="quick-cart__item-prices">'
      +       compareHtml
      +       (isGiftItem
        ? '<span class="quick-cart__item-price quick-cart__item-price--free" data-line-price>FREE</span>'
        : '<span class="quick-cart__item-price" data-line-price>' + formatPrice(item.final_line_price) + '</span>')
      +     '</div>'
      +     discountHtml
      +     '<div class="quick-cart__item-row">'
      +       '<div class="quick-cart__qty" role="group" aria-label="Quantity for ' + title + '">'
      +         '<button type="button" class="quick-cart__qty-btn" data-qty-action="dec" data-key="' + key + '" aria-label="Decrease quantity">'
      +           '<svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 10H14" stroke="#1C1C1C" stroke-opacity="0.6" stroke-width="1.5" stroke-linecap="round"/></svg>'
      +         '</button>'
      +         '<span class="quick-cart__qty-val" data-qty-val>' + item.quantity + '</span>'
      +         '<button type="button" class="quick-cart__qty-btn" data-qty-action="inc" data-key="' + key + '" aria-label="Increase quantity">'
      +           '<svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 6V14" stroke="#111111" stroke-width="1.5" stroke-linecap="round"/><path d="M6 10H14" stroke="#111111" stroke-width="1.5" stroke-linecap="round"/></svg>'
      +         '</button>'
      +       '</div>'
      +       '<button type="button" class="quick-cart__remove" data-remove-key="' + key + '" aria-label="Remove ' + title + '">'
      +         '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.4692 3.23248L13.151 4.71981H15.3505C16.0267 4.71981 16.575 5.26805 16.575 5.94433V6.85117C16.575 7.31354 16.2002 7.68838 15.7378 7.68838H4.263C3.80061 7.68838 3.42578 7.31354 3.42578 6.85117V5.94433C3.42578 5.26805 3.97401 4.71981 4.65031 4.71981H6.84982L7.53166 3.23248C7.73627 2.78615 8.18224 2.5 8.67324 2.5H11.3276C11.8186 2.5 12.2645 2.78615 12.4692 3.23248Z" stroke="#111111" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M15.2923 7.75064V14.9887C15.2923 16.3759 14.1817 17.5004 12.8118 17.5004H7.18946C5.81953 17.5004 4.70898 16.3759 4.70898 14.9887V7.75064" stroke="#111111" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>'
      +       '</button>'
      +     '</div>'
      +   '</div>'
      + '</li>';
  }

  var lastCart = null;

  /* Freshest cart we know of, falling back to the server-rendered cart the
     cart-gift section publishes. Lazy read: that section renders after this
     script tag. Lets the first quantity change merge the gift line for free. */
  function currentCart() { return lastCart || window.rrCartInitial || null; }

  function renderCart(cart) {
    if (!cart) return;
    lastCart = cart;

    if (countEl) countEl.textContent = cart.item_count;
    if (countWrapEl) {
      if (cart.item_count === 0) countWrapEl.setAttribute('hidden', '');
      else countWrapEl.removeAttribute('hidden');
    }

    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      if (cart.item_count === 0) el.classList.add('is-empty');
      else el.classList.remove('is-empty');
    });

    if (cart.item_count === 0) {
      if (itemsEl) { itemsEl.innerHTML = ''; itemsEl.setAttribute('hidden', ''); }
      if (emptyEl) emptyEl.removeAttribute('hidden');
      if (footerEl) footerEl.setAttribute('hidden', '');
      return;
    }

    if (emptyEl) emptyEl.setAttribute('hidden', '');
    if (itemsEl) {
      itemsEl.removeAttribute('hidden');
      var shownDiscounts = {};
      itemsEl.innerHTML = cart.items.map(function (it) { return renderItem(it, shownDiscounts); }).join('');
      swapOrderThumbs(itemsEl);
    }
    if (footerEl) footerEl.removeAttribute('hidden');
    if (subtotalEl) subtotalEl.textContent = formatPrice(cart.items_subtotal_price);
  }

  /* ---------- Cart API ---------- */
  function injectItemsFromSection(html) {
    if (!html || !itemsEl) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var freshItems = doc.querySelector('[data-quick-cart-items]');
    if (freshItems) {
      itemsEl.innerHTML = freshItems.innerHTML;
      if (freshItems.hasAttribute('hidden')) itemsEl.setAttribute('hidden', '');
      else itemsEl.removeAttribute('hidden');
    }
  }

  /* Whole drawer from the server-rendered section: lines, count, empty state,
     subtotal and the header badge. Used when a cart write returned the
     section (bundled section rendering), so nothing waits on /cart.js. */
  function paintFromSection(html) {
    if (!html) return false;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    if (!doc.querySelector('[data-quick-cart-items]')) return false;
    injectItemsFromSection(html);

    var freshCount = doc.querySelector('[data-quick-cart-count]');
    var count = freshCount ? parseInt(freshCount.textContent, 10) || 0 : 0;
    if (countEl) countEl.textContent = count;
    if (countWrapEl) {
      if (count === 0) countWrapEl.setAttribute('hidden', '');
      else countWrapEl.removeAttribute('hidden');
    }
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      if (count === 0) el.classList.add('is-empty');
      else el.classList.remove('is-empty');
    });
    if (emptyEl) {
      if (count === 0) emptyEl.removeAttribute('hidden');
      else emptyEl.setAttribute('hidden', '');
    }
    if (footerEl) {
      if (count === 0) footerEl.setAttribute('hidden', '');
      else footerEl.removeAttribute('hidden');
    }
    var freshSubtotal = doc.querySelector('[data-quick-cart-subtotal]');
    if (subtotalEl && freshSubtotal) subtotalEl.textContent = freshSubtotal.textContent;
    return true;
  }

  /* ---------- Add to cart (every Add to cart button) ----------
     ONE /cart/add.js carries the product AND, when it qualifies, the free
     bag (window.rrCartGiftWithGift), and asks for the drawer section in the
     same response (Shopify bundled section rendering). The drawer opens
     already showing the final state: watch + bag at FREE, real subtotal.
     /cart.js then runs in the background only to keep the cart state and
     to send rr:cart:added (Klaviyo Added to Cart) with the full cart. */
  /* Open on the tap with an "Adding" row (optimistic), so the drawer answers
     at once and fills in when the server responds. */
  function showAdding() {
    showPanel();
    if (!itemsEl || itemsEl.querySelector('.quick-cart__adding')) return;
    var row = document.createElement('li');
    row.className = 'quick-cart__adding';
    row.setAttribute('role', 'status');
    row.innerHTML = '<span class="quick-cart__adding-spinner" aria-hidden="true"></span><span>Adding to your bag…</span>';
    itemsEl.insertBefore(row, itemsEl.firstChild);
    itemsEl.removeAttribute('hidden');
    if (emptyEl) emptyEl.setAttribute('hidden', '');
  }

  function failAdding(err) {
    var row = itemsEl && itemsEl.querySelector('.quick-cart__adding');
    if (!row) return;
    var msg = (err && (err.description || err.message)) || 'Could not add to your bag. Please try again.';
    row.innerHTML = '<span>' + escapeHtml(msg) + '</span>';
    setTimeout(function () {
      if (row.parentNode) row.parentNode.removeChild(row);
      var cart = currentCart();
      if (cart) renderCart(cart);
    }, 2500);
  }

  function addToCart(lines, hints) {
    var items = typeof window.rrCartGiftWithGift === 'function'
      ? window.rrCartGiftWithGift(lines, hints)
      : lines;
    showAdding();

    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items, sections: 'quick-cart-india', sections_url: '/cart' })
    })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) throw data;
          return data;
        });
      })
      .then(function (data) {
        var painted = paintFromSection(data.sections && data.sections['quick-cart-india']);
        if (painted) showPanel();
        return fetch('/cart.js', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            if (painted) lastCart = cart;
            else { showPanel(); renderCart(cart); }
            document.dispatchEvent(new CustomEvent('rr:cart:added', { detail: { cart: cart, source: 'quick-cart' } }));
            return cart;
          }, function () {
            if (!painted) refreshCart();
            return null;
          });
      }, function (err) {
        failAdding(err);
        throw err;
      });
  }
  window.rrAddToCart = addToCart;

  /* Card / product page / recently viewed buttons call window.rrCardAtc. The
     sections keep their own copy as a fallback for when this drawer is not on
     the page; this one replaces it wherever the drawer is. */
  window.rrCardAtc = function (btn) {
    var variantId = parseInt(btn.getAttribute('data-variant-id'), 10);
    if (!variantId || btn.disabled) return;
    var origText = btn.textContent.trim();
    btn.disabled = true;
    btn.textContent = 'ADDING...';
    addToCart([{ id: variantId, quantity: 1 }]).then(function () {
      btn.textContent = 'ADDED';
      setTimeout(function () { btn.textContent = origText; btn.disabled = false; }, 1500);
    }, function () {
      btn.textContent = 'NOT AVAILABLE';
      setTimeout(function () { btn.textContent = origText; btn.disabled = false; }, 2000);
    });
  };

  function refreshCart() {
    if (isFetching) return;
    isFetching = true;
    Promise.all([
      fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }),
      /* Render the drawer section in the cart's own template context. Requesting
         it from '/' made Shopify build the home page context for a section that
         only ever shows cart data. */
      fetch('/cart?sections=quick-cart-india', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).catch(function () { return null; })
    ])
      .then(function (results) {
        var cart = results[0];
        var sections = results[1];
        renderCart(cart);
        if (sections && sections['quick-cart-india']) {
          injectItemsFromSection(sections['quick-cart-india']);
        }
      })
      .catch(function () { /* swallow */ })
      .then(function () { isFetching = false; });
  }

  function changeLine(key, quantity, rollback) {
    var li = itemsEl && itemsEl.querySelector('[data-item-key="' + CSS.escape(key) + '"]');
    if (li) li.classList.add('is-updating');

    /* Fold the gift-line adjustment into this same write. Previously the gift
       reconciler issued a second, sequential /cart/change.js right after this
       one, so every quantity click cost two round trips. /cart/update.js sets
       both lines at once and still returns the re-rendered drawer section. */
    var updates = {};
    updates[key] = quantity;
    if (typeof window.rrCartGiftPlan === 'function') {
      try { updates = window.rrCartGiftPlan(currentCart(), updates); } catch (err) { /* keep plain update */ }
    }

    return fetch('/cart/update.js?sections=quick-cart-india', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('change failed');
        return r.json();
      })
      .then(function (cart) {
        renderCart(cart);
        if (cart.sections && cart.sections['quick-cart-india']) {
          injectItemsFromSection(cart.sections['quick-cart-india']);
        }
        /* Pass the cart (and the already-rendered section) along with the event.
           Listeners can then update from this payload instead of issuing their
           own /cart.js round trip. `source` lets us skip re-rendering the drawer
           we just rendered above. */
        document.dispatchEvent(new CustomEvent('rr:cart:updated', {
          detail: { cart: cart, sections: cart.sections, source: 'quick-cart' }
        }));
      })
      .catch(function () {
        /* Write failed: restore the pre-click figures rather than leaving
           numbers the server never accepted, then resync from the server. */
        if (li) li.classList.remove('is-updating');
        if (typeof rollback === 'function') rollback();
        refreshCart();
      });
  }

  /* Rapid +/- clicks: coalesce into one request per line carrying the final
     quantity, and serialise writes so out-of-order responses can't leave the
     drawer showing a quantity the server never had. */
  var pendingQty = {};
  var pendingTimer = {};
  var pendingUndo = {};
  var writeChain = Promise.resolve();

  function queueChange(key, quantity, delay, undo) {
    if (undo) pendingUndo[key] = undo;
    pendingQty[key] = quantity;
    clearTimeout(pendingTimer[key]);
    pendingTimer[key] = setTimeout(function () {
      var target = pendingQty[key];
      var rollback = pendingUndo[key];
      delete pendingQty[key];
      delete pendingUndo[key];
      writeChain = writeChain.then(function () { return changeLine(key, target, rollback); });
    }, delay == null ? 250 : delay);
  }


  /* ---------- Optimistic paint ----------
     Updates quantity, line price and subtotal from the cart we already hold so
     the drawer responds on click instead of after the ~1s Shopify cart write.
     The server response still overwrites all of it a moment later, so any
     disagreement resolves in the server's favour. */
  function applyOptimistic(li, key, current, next) {
    var valEl = li && li.querySelector('[data-qty-val]');
    var priceEl = li && li.querySelector('[data-line-price]');

    /* Snapshot first so a failed write restores exactly what was on screen. */
    var prev = {
      qty: valEl ? valEl.textContent : null,
      price: priceEl ? priceEl.textContent : null,
      sub: subtotalEl ? subtotalEl.textContent : null
    };
    var undo = function () {
      if (valEl && prev.qty !== null) valEl.textContent = prev.qty;
      if (priceEl && prev.price !== null) priceEl.textContent = prev.price;
      if (subtotalEl && prev.sub !== null) subtotalEl.textContent = prev.sub;
    };

    if (valEl) valEl.textContent = next;

    var cart = currentCart();
    if (!cart || !cart.items) return undo;

    var item = null;
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].key === key) { item = cart.items[i]; break; }
    }
    if (!item) return undo;

    var unit = item.final_price;
    if (typeof unit !== 'number') return undo;

    if (priceEl) priceEl.textContent = formatPrice(unit * next);

    /* Only project the subtotal when no cart-level discount is in play — with
       one applied we cannot know the new total without asking the server. */
    var cartDiscounts = cart.cart_level_discount_applications || [];
    if (subtotalEl && cartDiscounts.length === 0 && typeof cart.items_subtotal_price === 'number') {
      var delta = (next - current) * unit;
      subtotalEl.textContent = formatPrice(cart.items_subtotal_price + delta);
    }
    return undo;
  }

  /* ---------- Event delegation ---------- */
  drawer.addEventListener('click', function (e) {
    var closeTrigger = e.target.closest('[data-quick-cart-close]');
    if (closeTrigger) {
      e.preventDefault();
      closeDrawer();
      return;
    }

    var qtyBtn = e.target.closest('[data-qty-action]');
    if (qtyBtn) {
      e.preventDefault();
      var action = qtyBtn.getAttribute('data-qty-action');
      var key = qtyBtn.getAttribute('data-key');
      var li = qtyBtn.closest('.quick-cart__item');
      var current = parseInt(li && li.querySelector('[data-qty-val]') ? li.querySelector('[data-qty-val]').textContent : '0', 10);
      var next = action === 'inc' ? current + 1 : current - 1;
      if (next < 0) next = 0;
      /* Paint the result immediately, then let the request settle behind it.
         Line price is unit final_price x qty, which is exact. */
      var undoFn = applyOptimistic(li, key, current, next);
      queueChange(key, next, null, undoFn);
      return;
    }

    var removeBtn = e.target.closest('[data-remove-key]');
    if (removeBtn) {
      e.preventDefault();
      var rKey = removeBtn.getAttribute('data-remove-key');
      var rLi = removeBtn.closest('.quick-cart__item');
      if (rLi) rLi.classList.add('is-removing');
      setTimeout(function () { queueChange(rKey, 0, 0); }, 200);
      return;
    }
  });

  /* ---------- ESC to close ---------- */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen) {
      closeDrawer();
    }
  });

  /* ---------- Triggers: ATC event + cart icon ---------- */
  /* OPEN the drawer only on a real add-to-cart action... */
  document.addEventListener('rr:cart:added', openDrawer);

  /* ...or on an explicit cart-icon click. */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-quick-cart-trigger]');
    if (!trigger) return;
    e.preventDefault();
    openDrawer();
  });

  /* REFRESH contents + count without opening (free-gift reconcile, background
     cart changes). Only re-fetches the drawer body when it is already open. */
  document.addEventListener('rr:cart:updated', function (e) {
    var detail = (e && e.detail) || {};

    /* We rendered this ourselves in changeLine() — nothing left to do. */
    if (detail.source === 'quick-cart') return;

    /* The emitter already has fresh cart JSON, so render from it rather than
       re-fetching /cart.js (and, when open, the drawer section too). This is
       what turned a single quantity change into six extra requests. */
    if (detail.cart) {
      renderCart(detail.cart);
      if (isOpen && detail.sections && detail.sections['quick-cart-india']) {
        injectItemsFromSection(detail.sections['quick-cart-india']);
      }
      return;
    }

    if (isOpen) refreshCart();
    else syncCount();
  });

  function syncCount() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (countEl) countEl.textContent = cart.item_count;
        if (countWrapEl) {
          if (cart.item_count === 0) countWrapEl.setAttribute('hidden', '');
          else countWrapEl.removeAttribute('hidden');
        }
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          if (cart.item_count === 0) el.classList.add('is-empty');
          else el.classList.remove('is-empty');
        });
      })
      .catch(function () {});
  }
})();
